function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.719 15.92l5.916 5.94c.5.503.484 1.304-.036 1.787a1.327 1.327 0 01-.907.353c-.36 0-.695-.138-.944-.388l-5.961-5.985a10.176 10.176 0 01-5.75 1.753C4.503 19.38 0 15.033 0 9.69 0 4.347 4.503 0 10.037 0c5.534 0 10.036 4.347 10.036 9.69a9.46 9.46 0 01-2.354 6.23zm-.264-6.23c0-3.95-3.328-7.162-7.418-7.162S2.618 5.74 2.618 9.69c0 3.95 3.328 7.162 7.419 7.162 4.09 0 7.418-3.213 7.418-7.162z"
})));